import { render, staticRenderFns } from "./VueFuse.vue?vue&type=template&id=61d4acbd&scoped=true&"
import script from "./VueFuse.vue?vue&type=script&lang=js&"
export * from "./VueFuse.vue?vue&type=script&lang=js&"
import style0 from "./VueFuse.vue?vue&type=style&index=0&id=61d4acbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d4acbd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61d4acbd')) {
      api.createRecord('61d4acbd', component.options)
    } else {
      api.reload('61d4acbd', component.options)
    }
    module.hot.accept("./VueFuse.vue?vue&type=template&id=61d4acbd&scoped=true&", function () {
      api.rerender('61d4acbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Divers/VueFuse.vue"
export default component.exports